import React, { createContext, useState, useContext, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

// Criação do contexto
const UserContext = createContext();

// Hook para usar o contexto
export const useUser = () => useContext(UserContext);

// Provedor do contexto
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Recupera o usuário do sessionStorage ao carregar o componente
    const storedUser = sessionStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [isLoading, setIsLoading] = useState(true); // Controle de carregamento inicial

  const fetchLogin = async (userData) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/login`, {
        method: "POST",
        body: JSON.stringify(userData),
      });
  
      if (!response || response.status != '200') {
        throw new Error("Erro ao autenticar o usuário.");
      }

      const data = await response.json();
      const decoded = jwtDecode(data.access_token);
      setUser(data);
      
      sessionStorage.setItem("user", JSON.stringify(data));
    } catch (error) {
      console.error("Erro na requisição:", error);
      throw error;
    }
  };

  const fetchUsuarios = async () => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/users`, {
        method: "GET",
        headers: {
          "Authentication": access_token,
        },
      });
  
      if (!response || response.status != '200') {
        throw new Error("Erro ao buscar lista de usuários.");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Erro na requisição:", error);
      throw error;
    }
  };

  const login = async (userData) => {
    await fetchLogin(userData);
  };

  const loadUserOptions = async () => {
    return await fetchUsuarios();
  };

  const userDecoded = () => {
    if (user?.access_token){
      const decoded = jwtDecode(user.access_token);
      return decoded;
    } else {
      return null;
    }
  };

  const logout = () => {
    setUser(null); // Remove o usuário do estado
    sessionStorage.removeItem("user"); // Limpa da session
  }; 

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false); // Finaliza o carregamento
  }, []);

  // Aguarde até que o carregamento inicial seja concluído
  if (isLoading) {
    return <div>Carregando...</div>;
  }

  return (
    <UserContext.Provider value={{ user, login, logout, userDecoded, loadUserOptions }}>
      {children}
    </UserContext.Provider>
  );
};
